<script setup lang="ts">
// The neutral screen a mode shows while it is still on its way (job #343; Tom
// 2026-09-26: choosing Listening or Script flashed the Speaking screen first).
// Two waits used to show Speaking: the player loading its course after a mode
// was picked on a page like /me, and the mode's own screen, a lazily loaded
// chunk, arriving a few frames after the switch. Both now show this instead —
// the page colour, where the mode overlay will sit, and a quiet spinner only
// if the wait runs long enough to be noticed.
//
// `quiet` is the same screen with no spinner: it stands under a mode while the
// mode fades in, so the fade shows the page colour rather than Speaking (job
// #345), and there is nothing there to wait for.
defineProps<{ quiet?: boolean }>()
</script>

<template>
  <div class="mode-cover" data-test="mode-cover" :aria-busy="!quiet">
    <span v-if="!quiet" class="mode-cover-spinner" aria-hidden="true"></span>
  </div>
</template>

<style scoped>
/* Where the mode overlays sit: the same box and the same layer, under the
   badge, the bottom nav and the tray. */
.mode-cover {
  position: fixed;
  inset: 0;
  top: var(--top-bands-h, 0px);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-primary);
}
.mode-cover-spinner {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 3px solid var(--text-muted, rgba(0, 0, 0, 0.15));
  border-top-color: transparent;
  opacity: 0;
  animation: mode-cover-in 0.2s ease 0.4s forwards, mode-cover-spin 0.9s linear infinite;
}
@keyframes mode-cover-in { to { opacity: 0.5; } }
@keyframes mode-cover-spin { to { transform: rotate(360deg); } }
@media (prefers-reduced-motion: reduce) {
  .mode-cover-spinner { animation: mode-cover-in 0.2s ease 0.4s forwards; }
}
</style>
